module.exports = __webpack_public_path__ + "static/media/lock.689317d9.jpg";